import { render } from "./ThankYou.vue?vue&type=template&id=b1e5ae0c&scoped=true"
import script from "./ThankYou.vue?vue&type=script&lang=js"
export * from "./ThankYou.vue?vue&type=script&lang=js"

import "./ThankYou.vue?vue&type=style&index=0&id=b1e5ae0c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1e5ae0c"]])

export default __exports__